import React, { useCallback, useState } from 'react'
import { ModalFeedback } from '..'
import { ShowFeedbackButton } from '../ShowFeedbackButton'

interface MenuSidebarFeedbackItemProps {
  isCollapsed: boolean
}

export const MenuSidebarFeedbackItem = ({ isCollapsed }: MenuSidebarFeedbackItemProps): JSX.Element => {
  const [showFeedbackModal, setShowFeedbackModal] = useState(false)

  const handleClose = useCallback(() => {
    setShowFeedbackModal(false)
  }, [])

  const handleOnClick = () => {
    setShowFeedbackModal(true)
  }

  return (
    <>
      <ShowFeedbackButton isCollapsed={isCollapsed} onClick={handleOnClick} />
      <ModalFeedback showFeedbackModal={showFeedbackModal} onClose={handleClose} />
    </>
  )
}
